import { MesfModal } from "@dexteel/mesf-core";
import { Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import {
	CATALOG_MATERIAL_INITIAL_VALUES,
	CatalogMaterial,
} from "../../../models/CatalogMaterial";
type Props = {
	show: boolean;
	onHide: (proceed: boolean) => void;
	materialName: string;
};
export const ConfirmMaterial = ({ show, onHide, materialName }: Props) => {
	const { reset } = useForm<CatalogMaterial>({
		defaultValues: CATALOG_MATERIAL_INITIAL_VALUES,
	});
	useEffect(() => {
		if (show) {
			reset();
		}
	}, [show]);
	return (
		<>
			<MesfModal
				title="CONFIRM"
				open={show}
				id="confirm-material-modal"
				handleClose={() => onHide(false)}
			>
				<MesfModal.Content style={{ padding: "15px 30px" }}>
					<Grid container spacing={1}>
						<Grid size={{ xs: 12, md: 12 }}>
							<p>{`A material with the name '${materialName}' already exists . Do you want to proceed?`}</p>
						</Grid>
					</Grid>
				</MesfModal.Content>
				<MesfModal.Actions style={{ padding: "20px 30px 30px" }}>
					<Grid container spacing={2} justifyContent="flex-end">
						<Grid size={{ xs: 12, md: 3 }} style={{ margin: 0 }}>
							<Button
								fullWidth
								variant="contained"
								color="inherit"
								onClick={() => onHide(false)}
							>
								No
							</Button>
						</Grid>
						<Grid size={{ xs: 12, md: 3 }}>
							<Button
								fullWidth
								onClick={() => onHide(true)}
								variant="contained"
								color="primary"
								type="submit"
							>
								Yes
							</Button>
						</Grid>
					</Grid>
				</MesfModal.Actions>
			</MesfModal>
		</>
	);
};
